import { createAction } from '@reduxjs/toolkit';
import { sendFloatingPhoneClickAnalytics } from "../../blocks/analytics";
import { isPageTypeFmc } from "../blocks/selectors";
import { getIsFloatingPhoneWidgetOpen } from "../selectors";
export var openFloatingPhone = createAction('OPEN_FLOATING_PHONE_CARD');
export var onFloatingPhoneClickAnalytics = function onFloatingPhoneClickAnalytics() {
  return function (dispatch, getState) {
    var state = getState();
    var isOpen = getIsFloatingPhoneWidgetOpen(state);
    var isConvergent = isPageTypeFmc(state);
    dispatch(openFloatingPhone());
    if (!isOpen) sendFloatingPhoneClickAnalytics(isConvergent);
  };
};